module.exports = __webpack_public_path__ + "img/ftlmdx.00cbbc5b.png";